import React from 'react';

import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="mt-12 text-center text-sm text-gray-500 py-4 border-t">
    <div className="mb-2">
      <Link to="/privacy-policy" className="underline hover:text-blue-600 mx-2">Privacy Policy</Link>
      |
      <Link to="/terms" className="underline hover:text-blue-600 mx-2">Terms of Service</Link>
    </div>
    © {new Date().getFullYear()} IncogJson. All rights reserved.
  </footer>
);
export default Footer;
